const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const TOOTH =
  "M12 4.5c-1.5-1.1-3.5-1.4-5-.4C5.2 5.2 4.8 6.9 5 8.7c.2 2 .9 3.5 1.3 5.3.4 1.7.7 3.8 1 5.7.1.8.7 1.3 1.3 1.3.9 0 1.3-.8 1.6-2.1.3-1.5.6-3.3 1.8-3.3s1.5 1.8 1.8 3.3c.3 1.3.7 2.1 1.6 2.1.6 0 1.2-.5 1.3-1.3.3-1.9.6-4 1-5.7.4-1.8 1.1-3.3 1.3-5.3.2-1.8-.2-3.5-2-4.6-1.5-1-3.5-.7-5 .4z";

export const ToothIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} {...base} aria-hidden="true">
    <path d={TOOTH} />
  </svg>
);

const Icon = ({ className = "", children }) => (
  <svg viewBox="0 0 24 24" className={className} {...base} aria-hidden="true">
    {children}
  </svg>
);

const IconRootCanal = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M12 8v3.5" />
    <path d="M10.6 13v4.2M13.4 13v4.2" />
  </Icon>
);

const IconExtraction = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M12 .8v2.6M10.7 2.1 12 .4l1.3 1.7" />
  </Icon>
);

const IconCleaning = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M18.6 1.6l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6z" />
    <path d="M20.8 7.6l.35 1 1 .35-1 .35-.35 1-.35-1-1-.35 1-.35z" />
  </Icon>
);

const IconFilling = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <circle cx="12" cy="8.6" r="1.7" />
  </Icon>
);

const IconCrown = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M8.6 3.1l1.2 1.6L12 2.4l2.2 2.3 1.2-1.6-.4 2.7H9z" />
  </Icon>
);

const IconBridge = (p) => (
  <Icon {...p}>
    <path d="M3.5 8.5c3-3.5 14-3.5 17 0" />
    <path d="M7 7.4v5.1a1.6 1.6 0 0 0 3.2 0V7.1" />
    <path d="M13.8 7.1v5.4a1.6 1.6 0 0 0 3.2 0V7.4" />
    <path d="M10.4 7v4.3" />
  </Icon>
);

const IconDenture = (p) => (
  <Icon {...p}>
    <path d="M4 8.5c1.5-4 14.5-4 16 0" />
    <path d="M4 8.5c0 3 1.5 5 4 5.5 1.5.3 2.5-.5 4-.5s2.5.8 4 .5c2.5-.5 4-2.5 4-5.5" />
    <path d="M8 8.2v2.5M12 8v2.8M16 8.2v2.5" />
  </Icon>
);

const IconBraces = (p) => (
  <Icon {...p}>
    <path d="M5 6.5c4-2 10-2 14 0M5 17.5c4 2 10 2 14 0" />
    <path d="M3.5 12h17" />
    <rect x="6" y="10" width="3" height="4" rx="0.8" />
    <rect x="10.5" y="10" width="3" height="4" rx="0.8" />
    <rect x="15" y="10" width="3" height="4" rx="0.8" />
  </Icon>
);

const IconImplant = (p) => (
  <Icon {...p}>
    <path d="M9 3.5h6" />
    <path d="M9.8 3.5l-.5 11.5c0 2 1 3.5 2.7 3.5s2.7-1.5 2.7-3.5L14.2 3.5" />
    <path d="M9.5 7h5M9.3 10.5h5.4M9.4 14h5.2" />
  </Icon>
);

const IconGum = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M6.5 13.5c1.8-1.4 3.7-1.4 5.5 0s3.7 1.4 5.5 0" />
  </Icon>
);

const IconKids = (p) => (
  <Icon {...p}>
    <path d={TOOTH} />
    <path d="M12 9.6c-.5-.8-1.7-.8-2 .1-.3.8.2 1.4 2 2.5 1.8-1.1 2.3-1.7 2-2.5-.3-.9-1.5-.9-2-.1z" />
  </Icon>
);

export const TREATMENT_ICONS = {
  rct: IconRootCanal,
  extraction: IconExtraction,
  cleaning: IconCleaning,
  filling: IconFilling,
  crown: IconCrown,
  bridge: IconBridge,
  denture: IconDenture,
  braces: IconBraces,
  gum: IconGum,
  kids: IconKids,
  implant: IconImplant,
};
